import React, { useState } from 'react';
import { LuCopy, LuRefreshCw, LuTrash2, LuCheck } from 'react-icons/lu';
import formatBRL from '../../../shared/utils/formatBRL';
import './PaymentLinkTable.css';

const summarizeProducts = (products) =>
  (products || []).map((p) => `${p.ProductName} (x${p.ProductQuantity})`).join(', ');

const formatDate = (value) => {
  if (!value) return '—';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '—' : date.toLocaleDateString('pt-BR');
};

const STATUS_LABELS = {
  active: 'Ativo',
  paid: 'Pago',
  expired: 'Expirado',
  canceled: 'Cancelado',
};

const CopyLinkButton = ({ url }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(url);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <button type="button" className="payment-link-table__icon-btn" onClick={handleCopy} aria-label="Copiar link">
      {copied ? <LuCheck size={16} /> : <LuCopy size={16} />}
    </button>
  );
};

const PaymentLinkTable = ({ links, onSync, onDelete }) => {
  if (!links || links.length === 0) {
    return <p className="text-muted mb-0">Nenhum link de pagamento gerado ainda.</p>;
  }

  return (
    <div className="payment-link-table-wrapper">
      <table className="payment-link-table">
        <thead>
          <tr>
            <th>Data</th>
            <th>Nome</th>
            <th>Cliente</th>
            <th>Produtos</th>
            <th>Frete</th>
            <th>Valor</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {links.map((link) => (
            <tr key={link._id}>
              <td className="text-muted">{formatDate(link.createdAt)}</td>
              <td className="payment-link-table__name">{link.name}</td>
              <td className="text-muted">
                {link.customer?.name || 'Carregado após o pagamento'}
              </td>
              <td>{summarizeProducts(link.products)}</td>
              <td className="text-muted">
                {link.delivery?.type ? `${link.delivery.type} — ${formatBRL(link.delivery.fee || 0)}` : '—'}
              </td>
              <td>{formatBRL((link.amount || 0) / 100)}</td>
              <td>
                <span className={`payment-link-badge payment-link-badge--${link.status}`}>
                  {STATUS_LABELS[link.status] || link.status}
                </span>
              </td>
              <td className="payment-link-table__actions">
                <CopyLinkButton url={link.url} />
                <button
                  type="button"
                  className="payment-link-table__icon-btn"
                  onClick={() => onSync(link)}
                  aria-label={`Ressincronizar ${link.name}`}
                >
                  <LuRefreshCw size={16} />
                </button>
                <button
                  type="button"
                  className="payment-link-table__icon-btn payment-link-table__icon-btn--danger"
                  onClick={() => onDelete(link)}
                  aria-label={`Excluir ${link.name}`}
                >
                  <LuTrash2 size={16} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PaymentLinkTable;
